// extracted by mini-css-extract-plugin
module.exports = {"greenCardForm":"GreenCardForm_greenCardForm__34lJt"};